import { Component, ChangeDetectionStrategy } from '@angular/core';
// import config.js
import config from '../../../../../config';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  applicationName = config.application_name;
  applicationVersion = config.application_version;
  copyrightYear = new Date().getFullYear();
  readonly supportContactHref = this.getSupportContactHref(
    config.support_contact,
  );

  private getSupportContactHref(value: string): string | null {
    const contact = value.trim();
    if (!contact || contact === 'REPLACE_ME') {
      return null;
    }

    let hasWhitespace = false;
    for (const character of contact) {
      if (character.trim() === '') {
        hasWhitespace = true;
        break;
      }
    }

    const atIndex = contact.indexOf('@');
    const dotIndex = contact.indexOf('.', atIndex + 2);
    if (
      atIndex > 0 &&
      atIndex === contact.lastIndexOf('@') &&
      dotIndex > atIndex + 1 &&
      dotIndex < contact.length - 1 &&
      !hasWhitespace
    ) {
      return `mailto:${contact}`;
    }

    try {
      const url = new URL(contact);
      return url.protocol === 'https:' && !url.username && !url.password
        ? url.href
        : null;
    } catch {
      return null;
    }
  }
}
